import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PAGES_ENDPOINTS } from '../constants/Endpoints';
import Admin from '../pages/Admin';
import Login from '../pages/Login';
import Profile from '../pages/Profile';
import Settings from '../pages/Settings';
import Students from '../pages/Students';
import Subjects from '../pages/Subjects';
import Teachers from '../pages/Teachers';
import DefaultRoute from './DefaultRoute';
import PrivateRoute from './PrivateRoute';

const AppRoutes = ({ themeColor, setThemeColor }) => {
  return (
    <Routes>
      <Route path={PAGES_ENDPOINTS.LOGIN} exact element={<Login />} />
      <Route
        path={PAGES_ENDPOINTS.MAIN}
        exact
        element={
          <PrivateRoute>
            <Students themeColor={themeColor} />
          </PrivateRoute>
        }
      />
      <Route
        path={PAGES_ENDPOINTS.SUBJECTS}
        exact
        element={
          <PrivateRoute>
            <Subjects />
          </PrivateRoute>
        }
      />
      <Route
        path={PAGES_ENDPOINTS.TEACHERS}
        exact
        element={
          <PrivateRoute>
            <Teachers />
          </PrivateRoute>
        }
      />
      <Route
        path={PAGES_ENDPOINTS.SETTINGS}
        exact
        element={
          <PrivateRoute>
            <Settings themeColor={themeColor} setThemeColor={setThemeColor} />
          </PrivateRoute>
        }
      />
      <Route
        path={PAGES_ENDPOINTS.PROFILE}
        exact
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />
      <Route
        path={PAGES_ENDPOINTS.ADMIN}
        exact
        element={
          <PrivateRoute isAdminRoute>
            <Admin />
          </PrivateRoute>
        }
      />
      <Route path="*" exact element={<DefaultRoute />} />
    </Routes>
  );
};

export default AppRoutes;
